import { getAuthUserId } from '../utils/authUser';

const parseAllowlist = (raw: string | undefined) =>
  String(raw || '')
    .split(',')
    .map((value) => value.trim())
    .filter(Boolean);

const DEFAULT_SITE_ADMIN_USER_IDS = [
  '912fdeee-47f8-489e-acf5-1fada7b0b975',
  'c5f23de6-7252-421d-996b-6b059a6d1ecc'
];

const configuredSiteAdminUserIds = parseAllowlist(process.env.REACT_APP_SITE_ADMIN_USER_IDS);

export const SITE_ADMIN_USER_IDS = configuredSiteAdminUserIds.length > 0
  ? configuredSiteAdminUserIds
  : DEFAULT_SITE_ADMIN_USER_IDS;

export const isBootstrapSiteAdminUser = (userId?: string | null) =>
  Boolean(userId && SITE_ADMIN_USER_IDS.includes(String(userId).trim()));

export const isSiteAdminUser = (userOrId?: any) => {
  if (!userOrId) return false;

  if (typeof userOrId === 'string') {
    return isBootstrapSiteAdminUser(userOrId);
  }

  const userId = getAuthUserId(userOrId);
  return Boolean(userOrId?.isSiteAdmin === true || isBootstrapSiteAdminUser(userId));
};

export const ENABLE_DEBUG_ROUTES = process.env.REACT_APP_ENABLE_DEBUG_ROUTES === 'true';
